var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-clock",
    transform: "translate(4030 -530)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1205",
    "data-name": "Rectangle 1205",
    width: 36,
    height: 36,
    rx: 4,
    transform: "translate(-4030 530)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "timer",
    transform: "translate(-4027.76 534.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6901",
    "data-name": "Path 6901",
    d: "M16.875,12.375h1.748v7.867H16.875Z",
    transform: "translate(-2.479 -2.258)",
    fill: "#213364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6902",
    "data-name": "Path 6902",
    d: "M14.625,2.25H19.87V4H14.625Z",
    transform: "translate(-1.977)",
    fill: "#213364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6903",
    "data-name": "Path 6903",
    d: "M25.76,9.387,24.519,8.155l-1.967,1.967a9.562,9.562,0,1,0,1.031,1.442ZM15.27,24.247a7.867,7.867,0,1,1,7.867-7.867,7.867,7.867,0,0,1-7.867,7.867Z",
    transform: "translate(0 -1.019)",
    fill: "#213364"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.7882893090ee4d9d379a3a3faccf5693.svg";
export { ForwardRef as ReactComponent };